import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../app/hooks";

import { HTTP_STATUS } from "../http/constants/http.status";

import LoaderContainer from "../components/shared/loaderContainer/LoaderContainer";
import { find, isEmpty } from "lodash";
import { setToastData, resetToastData } from "../app/toastReducer";
import { AppConstants } from "../constants/AppConstants";
import environment from "../environment";
import { getFailureMessage } from "../util/ErrorUtil";
import { getUser } from "../http/ticket-service";
import { setZendeskUser } from "../app/userManagementReducer";
import { useTranslation } from "react-i18next";

type Props = {
  children: React.ReactNode;
};

const AppInitialize = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(true);
  const [failureMessage, setFailureMessage] = useState("");
  const userProfileInfo: any = useAppSelector(
    (state) => state.userManagement.userProfileInfo
  );

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(resetToastData());
    setLoading(false);
  }, []);

  return !isLoading ? (
    <LoaderContainer isLoading={isLoading}>{children}</LoaderContainer>
  ) : (
    <LoaderContainer
      isLoading={isLoading}
      children={undefined}
    ></LoaderContainer>
  );
};

export default AppInitialize;
